import React from 'react';
import { Chip } from '@mui/material';
import { getStatusColor } from '../../utils/formatters';

/**
 * StatusBadge component for displaying work item status with modern styling
 * @param {Object} props - Component props
 * @param {String} props.status - Status text
 * @param {Object} props.style - Additional style properties
 * @returns {JSX.Element} StatusBadge component
 */
const StatusBadge = ({ status, style = {} }) => {
  if (!status) return null;
  
  // Get the appropriate color for the status
  const statusColor = getStatusColor(status);
  
  // Determine text color - use black for Approved status, white for others
  const textColor = status.toLowerCase() === 'approved' ? '#000000' : '#FFFFFF';
  
  return (
    <Chip
      label={status}
      sx={{
        backgroundColor: statusColor,
        color: textColor,
        fontWeight: 500,
        fontSize: '0.8125rem',
        height: '28px',
        borderRadius: 2,
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        },
        ...style
      }}
      size="small"
    />
  );
};

export default StatusBadge;
